import * as yup from 'yup';

export const AncillaryCostValidationScheme = yup.object().shape({
    description: yup.string().required('Description is required').max(255, "Description must be less than 255 characters"),
    paymentDate: yup.date().nullable().required('Payment Date is required').typeError('Payment Date is required'),
    cost: yup.string().required('Cost (excl. VAT) is required').typeError('Cost (excl. VAT) is required')
});
